import type { SP80022Parameters, SP80090BParameters, TunableBiasParameters, GaussianParameters } from '@/types'

export const APP_VERSION = '1.2.0'
export const APP_NAME = 'BitAssay'
export const APP_FULL_TITLE = 'BitAssay — Statistical Test Suite for Physical Random Number Generators'

export const DEFAULT_SP80022_PARAMS: SP80022Parameters = {
  alpha: 0.01,
  blockSizeFreq: 128,
  templateLength: 9,
  blockSizeLinear: 500,
  patternLength: 10,
}

export const DEFAULT_SP80090B_PARAMS: SP80090BParameters = {
  symbolSize: 1,
  numPermutations: 1000,
  verboseIID: false,
}

export const DEFAULT_TUNABLE_BIAS_PARAMS: TunableBiasParameters = {
  targetBias: 0.5,
  stabilityBlocks: 100,
  maxLag: 1000,
  serialPatternLength: 8,
  maxConditionalOrder: 10,
  alpha: 0.01,
}

export const DEFAULT_GAUSSIAN_PARAMS: GaussianParameters = {
  useEstimated: true,
  alpha: 0.01,
}

export const SP80022_TEST_NAMES = [
  'Frequency (Monobit)',
  'Block Frequency',
  'Runs',
  'Longest Run of Ones',
  'Binary Matrix Rank',
  'Discrete Fourier Transform',
  'Non-Overlapping Template',
  'Overlapping Template',
  "Maurer's Universal",
  'Linear Complexity',
  'Serial',
  'Approximate Entropy',
  'Cumulative Sums',
  'Random Excursions',
  'Random Excursions Variant',
]

export const TUNABLE_BIAS_TEST_NAMES = [
  'Bias Accuracy',
  'Bias Stability',
  'Generalized Runs',
  'Generalized Serial',
  'Autocorrelation',
  'Conditional Entropy',
  'Generalized Approximate Entropy',
  'Spectral Analysis',
  'Dwell Time',
]

export const GAUSSIAN_TEST_NAMES = [
  'Shapiro-Wilk',
  'Anderson-Darling',
  "D'Agostino-Pearson",
  'Kolmogorov-Smirnov',
]

// Minimum data requirements
export const MIN_BITS_SP80022 = 100_000      // NIST recommends 1,000,000 but works from 100K
export const RECOMMENDED_BITS_SP80022 = 1_000_000
export const MIN_SAMPLES_SP80090B = 1_000
export const RECOMMENDED_SAMPLES_SP80090B = 1_000_000
export const MIN_SAMPLES_GAUSSIAN = 20        // Shapiro-Wilk minimum
